import React from 'react'
import {
  Create,
  SimpleForm,
  FileInput,
  FileField,
  SelectInput,
  TextInput,
  required,
} from 'react-admin'

export const MLTaskCreate = () => {
  return (
    <Create title="Run Machine Learning Predictions">
      <SimpleForm>
        <TextInput
          source="model_name"
          label="Model Name"
          defaultValue="Generali"
          validate={[required()]}
          fullWidth
        />
        <SelectInput
          source="ml_provider"
          label="ML Provider"
          choices={[
            { id: 'AWS', name: 'Amazon Web Services (SageMaker)' },
            { id: 'GCP', name: 'Google Cloud Platform (Vertex AI)' },
            { id: 'OpenAI', name: 'OpenAI (GPT-4.1)' },
          ]}
          defaultValue="OpenAI"
          validate={[required()]}
          fullWidth
        />
        <FileInput
          source="file"
          label="Source Spreadsheet (.xlsx)"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          validate={[required()]}
        >
          <FileField source="src" title="title" />
        </FileInput>
        <p className="text-sm text-stone-500 mt-2">
          Note: The spreadsheet should contain &quot;Supplier&quot; and
          &quot;Description&quot; columns for the best results.
        </p>
      </SimpleForm>
    </Create>
  )
}
